import {vpost} from "@/util/post";

export const sys = {
    confList() {
        return new Promise((resolve, reject) => {
            try {
                vpost("/sys/list").then(res => resolve(res.data));
            } catch (e) {
                reject(e);
            }
        })
    },
    confUpdate(key, value) {
        let formData = new FormData();
        formData.append("key", key);
        formData.append("value", value);
        return vpost("/sys/update", formData)
    },

    // "/getTenentCosTempKey"

    getTencentCosTempKey() {
        return vpost("/getTenentCosTempKey");
    },

    getCosData() {
        return vpost("/getCosData");
    },

    listLogHttp(pageSize, pageCurrent, keyword) {
        let dto = {
            pageCurrent, pageSize, keyword
        };
        return vpost("/sys/logHttp", dto);
    },
    listLogCos(pageSize, pageCurrent, keyword) {
        let dto = {
            pageCurrent, pageSize, keyword
        };
        return vpost("/sys/logCos", dto);
    },

};
